/* eslint-disable no-console */
import ErrorModal from "@app/modals/ErrorModal"
import { appStore } from "@app/store/store"
import { getUrl } from "@app/utils/htmlUtils"
import { useModal, uuidv4 } from "@tecreation/funnel-components"
import { ResponseError } from "@tecreation/js-state-react"
import { useRef, useState } from "react"

import * as PACKAGE from "../../../package.json"
var version = PACKAGE.version

const detectDeviceType = () => (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent) ? "Mobile" : "Desktop")

const sendTrace = error => {
	let uri = getUrl()
	let message = error.message,
		body,
		db = false,
		stackTrace = error.stack

	if (error instanceof ResponseError) {
		body = {
			ApplicationVersion: version,
			Endpoint: error.response.url,
			StatusCode: error.response.status,
			params: error.params,
			// @ts-ignore
			Body: error.sendedBody,
			Token: error.response.data.traceToken,
			Response: error.response.data,
		}

		message = error.response.data.errorMessage || error.message
	} else {
		body = {
			ApplicationVersion: version,
		}
	}
	// @ts-ignore
	body.localStorage = window.localStorage

	// @ts-ignore
	body.userAgent = window.navigator.userAgent
	// @ts-ignore
	body.device = detectDeviceType()

	body = JSON.stringify(body, null, 2)

	let type = appStore.get("core.kioskMode") ? "KIOSK" : appStore.get("core.employeeMode") ? "EMPLOYEE" : appStore.get("core.onSiteMode") ? "LOUNGER" : "FUNNEL"
	message = type + ";" + message

	fetch("/api/connector/error/trace", {
		method: "POST",
		headers: {
			apiKey: appStore.get("settings.connectorKey"),
			"content-type": "application/json; charset=utf-8",
			Authorization: "Bearer " + appStore.get("core.accessToken"),
		},
		body: JSON.stringify({
			uri,
			message,
			body,
			db,
			stackTrace,
		}),
	}).catch(e => console.error(e))
}

export const useRaiseError = () => {
	const [applicationError, setApplicationError] = useState(undefined)
	const { showModal } = useModal()
	const handled = useRef(false)
	if (applicationError && !handled.current) {
		sendTrace(applicationError)
		showModal(ErrorModal, { error: applicationError })
		handled.current = true
		return
	}
	/**
	 * A function that raises an error if a translations exists for the raised error in the cms then the error will be translated.
	 *
	 * If there is an translation all placeholder will get replaced with the values of the replacements object
	 * @param {Error | Response} responseOrError
	 * @param {{}} [replacements] A Object were the keys are the placeholder in message body(from cms) and the value is the replacement.
	 * @param {boolean} [brokeApplication] indicates if the error destroys the application
	 */
	return (responseOrError, replacements, brokeApplication, sendError = false) => {
		let error = {
			id: uuidv4(),
			body: "",
			errorMessage: undefined,
			replacements,
		}
		if (brokeApplication) {
			setApplicationError(responseOrError)
			return
		}

		if (sendError && error instanceof ResponseError) {
			sendTrace(responseOrError)
		}
		if (responseOrError instanceof ResponseError) {
			const body = responseOrError.response.data
			if (body) {
				error.body = body
				let { errorMessage } = body
				if (errorMessage && typeof errorMessage == "string") {
					errorMessage = errorMessage.split(";")[0]
					error.errorMessage = errorMessage
				} else {
					error.errorMessage = "unknown error"
					if (errorMessage) {
						error.errorMessage = errorMessage instanceof Error ? errorMessage.message : JSON.stringify(errorMessage)
					}
				}
			} else {
				//unkown error
				error.errorMessage = "unknown error"
			}
		} else {
			// @ts-ignore
			error.errorMessage = responseOrError.message
		}

		if (brokeApplication) {
			error.errorMessage = "something went wrong. please try again"
		}

		appStore.set(state => ({
			errors: [...(state.errors || []), error],
		}))
	}
}
